<template>
  <button
    @click="$emit('click')"
    type="button"
    class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150"
  >
    <font-awesome-icon
      v-if="icon"
      :icon="icon"
      class="fa-fw nav-icon mr-1"
    ></font-awesome-icon>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "BaseButtonWhite",
  props: ["icon"],
};
</script>
